var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.431 4.01235L9.98758 1.56836C9.90633 1.48709 9.80986 1.42262 9.70369 1.37864C9.59752 1.33465 9.48372 1.31201 9.36879 1.31201C9.25387 1.31201 9.14007 1.33465 9.0339 1.37864C8.92773 1.42262 8.83126 1.48709 8.75 1.56836L2.00649 8.31243C1.92488 8.39338 1.86019 8.48975 1.81615 8.59594C1.77212 8.70212 1.74964 8.81599 1.75 8.93094V11.3749C1.75 11.607 1.84219 11.8296 2.00629 11.9936C2.17038 12.1577 2.39294 12.2499 2.625 12.2499H5.06899C5.18394 12.2503 5.29781 12.2278 5.404 12.1838C5.51018 12.1397 5.60655 12.075 5.6875 11.9934L12.431 5.24993C12.5123 5.16867 12.5768 5.0722 12.6207 4.96603C12.6647 4.85986 12.6874 4.74606 12.6874 4.63114C12.6874 4.51621 12.6647 4.40242 12.6207 4.29624C12.5768 4.19007 12.5123 4.0936 12.431 4.01235ZM2.80602 8.74993L7.4375 4.11844L8.35024 5.03118L3.71875 9.66211L2.80602 8.74993ZM2.625 9.80594L4.19399 11.3749H2.625V9.80594ZM5.25 11.1939L4.33727 10.2812L8.96875 5.64969L9.88149 6.56243L5.25 11.1939ZM10.5 5.94391L8.05602 3.49993L9.36852 2.18743L11.8125 4.63086L10.5 5.94391Z",
    fill: "#252526"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil2);
export default __webpack_public_path__ + "static/media/pencil-2.8bd4328d3f1768045f2577a264a1cd4c.svg";
export { ForwardRef as ReactComponent };